export const TIME_ZONES = [
  // North America
  { id: "Pacific/Honolulu", name: "Hawaii" },
  { id: "America/Anchorage", name: "Alaska" },
  { id: "America/Los_Angeles", name: "Pacific Time (US & Canada)" },
  { id: "America/Denver", name: "Mountain Time (US & Canada)" },
  { id: "America/Chicago", name: "Central Time (US & Canada)" },
  { id: "America/New_York", name: "Eastern Time (US & Canada)" },
  { id: "America/Toronto", name: "Eastern Time (Canada)" },
  { id: "America/Mexico_City", name: "Central Time (Mexico)" },
  { id: "America/Phoenix", name: "Arizona (No DST)" },

  // South America
  { id: "America/Bogota", name: "Colombia" },
  { id: "America/Lima", name: "Peru" },
  { id: "America/Santiago", name: "Chile" },
  { id: "America/Argentina/Buenos_Aires", name: "Argentina" },
  { id: "America/Sao_Paulo", name: "Brazil" },

  // Europe
  { id: "Europe/London", name: "United Kingdom" },
  { id: "Europe/Dublin", name: "Ireland" },
  { id: "Europe/Paris", name: "France" },
  { id: "Europe/Berlin", name: "Germany" },
  { id: "Europe/Amsterdam", name: "Netherlands" },
  { id: "Europe/Madrid", name: "Spain" },
  { id: "Europe/Rome", name: "Italy" },
  { id: "Europe/Stockholm", name: "Sweden" },
  { id: "Europe/Athens", name: "Greece" },
  { id: "Europe/Istanbul", name: "Turkey" },

  // Africa
  { id: "Africa/Cairo", name: "Egypt" },
  { id: "Africa/Johannesburg", name: "South Africa" },
  { id: "Africa/Nairobi", name: "Kenya" },
  
  // Middle East
  { id: "Asia/Jerusalem", name: "Israel" },
  { id: "Asia/Riyadh", name: "Saudi Arabia" },
  { id: "Asia/Dubai", name: "United Arab Emirates" },
  { id: "Asia/Qatar", name: "Qatar" },

  // Asia
  { id: "Asia/Kolkata", name: "India" },
  { id: "Asia/Colombo", name: "Sri Lanka" },
  { id: "Asia/Dhaka", name: "Bangladesh" },
  { id: "Asia/Bangkok", name: "Thailand" },
  { id: "Asia/Singapore", name: "Singapore" },
  { id: "Asia/Hong_Kong", name: "Hong Kong" },
  { id: "Asia/Tokyo", name: "Japan" },
  { id: "Asia/Seoul", name: "South Korea" },
  { id: "Asia/Shanghai", name: "China" },

  // Oceania
  { id: "Australia/Perth", name: "Western Australia" },
  { id: "Australia/Adelaide", name: "Australia (Adelaide)" },
  { id: "Australia/Sydney", name: "Australia (Sydney)" },
  { id: "Pacific/Auckland", name: "New Zealand" },
];
